import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { DEFAULT_ROUTE_PROBLEMS_SCHEMA } from '@/components/RouteProblems/routeProblems'
import { RouteProblemsPage } from '@/components/RouteProblems/RouteProblemsPage'
import { requirePermission } from '@/utils/auth'

export type RouteProblemsSearch = {
  schema?: string
  inactive?: boolean
}

export const Route = createFileRoute('/route-problems')({
  beforeLoad: () => requirePermission('route_problems'),
  validateSearch: (raw: Record<string, unknown>): RouteProblemsSearch => ({
    schema: typeof raw.schema === 'string' && raw.schema ? raw.schema : undefined,
    inactive: raw.inactive === true || raw.inactive === 'true' ? true : undefined,
  }),
  component: RouteProblemsRoute,
})

function RouteProblemsRoute() {
  const { schema, inactive } = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <RouteProblemsPage
      schema={schema ?? DEFAULT_ROUTE_PROBLEMS_SCHEMA}
      includeInactive={inactive === true}
      onSchemaChange={value =>
        navigate({
          search: previous => ({ ...previous, schema: value === DEFAULT_ROUTE_PROBLEMS_SCHEMA ? undefined : value }),
          replace: true,
        })
      }
      onIncludeInactiveChange={value =>
        navigate({ search: previous => ({ ...previous, inactive: value || undefined }), replace: true })
      }
    />
  )
}
